import axios from '~/utils/axios';
import _axios from 'axios';
import querystring from 'querystring';

import { LYC_API_URL } from '~/env';

export const beginKycCheck = (props: {
  profileType: string;
  profileId: string;
  targetKycLevel: string;
}) => {
  return axios.post(
    `/kyc/startKycLevelWorkflow?profileType=${props.profileType}&profileId=${props.profileId}&targetKycLevel=${props.targetKycLevel}`
  );
};

export const resetKycProgress = (props: { profileType: string; profileId: string }) => {
  return axios.post(
    `/kyc/resetKycProgress?profileType=${props.profileType}&profileId=${props.profileId}`
  );
};

type ForceKycUpdateReq = {
  kycLevel: string;
  note?: string;
};

export const forceKycUpdateIndividual = (props: { profileId: string; body: ForceKycUpdateReq }) => {
  return axios
    .post<any>(`/individuals/${props.profileId}/kycLevel/forceUpdate`, props.body)
    .then((res) => res.data);
};

export const forceKycUpdateBusiness = (props: { profileId: string; body: ForceKycUpdateReq }) => {
  return axios
    .post<any>(`/businesses/${props.profileId}/kycLevel/forceUpdate`, props.body)
    .then((res) => res.data);
};

export const getKycCredentials = () => {
  return axios.get<{ username: string; password: string }>('/kyc/kycAppCredentials');
};

export const kycAppLogin = (username: string, password: string) => {
  return _axios.post(
    `${LYC_API_URL}/camunda/api/admin/auth/user/default/login/tasklist`,
    querystring.stringify({
      username,
      password,
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
};

export const openKycApp = () => {
  window.open(`/camunda/app/tasklist/default/`);
};
